import { createAction, props } from '@ngrx/store';
import { Customer } from '@core/user/utilities/user.model';

// GET
export const GET_USER = '[USER]: GET';
export const GET_USER_SUCCESS = '[USER]: GET - SUCCESS';
export const GET_USER_FAIL = '[USER]: GET - FAIL';
export const getUser = createAction(GET_USER);
export const getUserSuccess = createAction(GET_USER_SUCCESS, props<{ user: Customer }>());
export const getUserFail = createAction(GET_USER_FAIL, props<{ erroMessage: string }>());

// CLEAR
export const CLEAR_USER = '[USER]: CLEAR';
export const clearUser = createAction(CLEAR_USER);
